exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#notifelement {\n    min-height: 50vh;\n}\n", ""]);

// exports
